import z from 'zod'

export const userPreferenceModel = z.object({
  __typename: z.literal('UserPreference').default('UserPreference'),
  id: z.string(),
  userId: z.string(),
  displayName: z.string(),
  avatarUrl: z.string().nullable(),
  locale: z.string(),
  allowedPosts: z.boolean(),
  termOfUseAcceptedDate: z.string().datetime().nullable(),
  termOfUseAcceptedIP: z.string().nullable(),
  allowedApplications: z.array(z.string()),
  registeredApplications: z.array(z.string()),
  isActive: z.boolean(),
  isRoot: z.boolean(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
})

export type UserPreferenceModel = z.infer<typeof userPreferenceModel>
